import mitt from 'mitt';
import NioModal from '@/components/UI/NioModal.vue';

export default {
    install(Vue) {
        const bus = mitt();
        const modal = {
            get bus() {
                return bus;
            },

            open(name, params) {
                bus.emit('toggle', { name, params, state: true });
            },

            close(name, params) {
                bus.emit('toggle', { name, params, state: false });
            },

            toggle(name, params) {
                bus.emit('toggle', { name, params });
            },
        };

        Vue.component('NioModal', NioModal);
        Vue.prototype.$modal = modal;
        Vue.modal = modal;
    },
};
